import React, { useMemo } from 'react';
import { HeaderTitle, HeaderWrapper } from './ShazamOverview.styles';

import KPIShortFormVideoMobileLoader from 'components/data-containers/KPIs/ShortFormVideo/KPIShortFormVideoMobileLoader';
import KPILoader from 'components/utility/ContentLoader/KPILoader/KPILoader';
import { KeyValueGroupContainer } from '../ShortFormVideoPerformance/ShortFormVideoKPIs.style';
import { HeaderWrapper as WrapperInTooltip } from 'components/data-visualization/Table/DropdownHead';

interface IShazamOverviewKPIsProps {
  current: number;
  previous: number;
  change: number;
  title: string;
  isPending: boolean;
  isMobileView: boolean;
}

const ShazamOverviewKPIs: React.FC<IShazamOverviewKPIsProps> = (props) => {
  const { current, previous, title, isPending, change, isMobileView } = props;
  const dataColors = ['#001247'];
  const condition = useMemo(
    () => title.toLowerCase().includes('this week to date'),
    [title]
  );

  return (
    <>
      <HeaderWrapper isMobileView={isMobileView}>
        <HeaderTitle marginBottom={isMobileView && '2em'}>
          <WrapperInTooltip key={title} condition={condition}>
            {title}
          </WrapperInTooltip>
        </HeaderTitle>
      </HeaderWrapper>

      {isPending &&
        (isMobileView ? (
          <KPIShortFormVideoMobileLoader />
        ) : (
          <KPILoader showPrevious showChange showRow />
        ))}

      {!isPending && (
        <KeyValueGroupContainer
          items={[
            {
              label: 'TAGS',
              metric: { value: [{ value: current, type: 'number' }] },
            },
            {
              label: 'Previous',
              metric: { value: [{ value: previous, type: 'number' }] },
            },
            {
              label: 'Change',
              metric: {
                value: [{ value: change, type: 'trend' }],
                type: isMobileView ? 'newTrend' : 'rawNumber',
              },
            },
          ]}
          compareMode={null}
          dataColors={dataColors}
          showRow
          isMobileView={isMobileView}
        />
      )}
    </>
  );
};

export default ShazamOverviewKPIs;
